export default {
    "name": "InventoryType",
    "kind": "HoudiniQuery",
    "hash": "54013b0a20551be7228b75f67c992788e893cfa9c15acb0d74f1a7dd6943b9dc",

    "raw": `query InventoryType($inventoryTypeId: Int!) {
  inventoryType(id: $inventoryTypeId) {
    manufacturers {
      id
      name
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventoryType": {
                "type": "InventoryType",
                "keyRaw": "inventoryType(id: $inventoryTypeId)",

                "selection": {
                    "fields": {
                        "manufacturers": {
                            "type": "Manufacturer",
                            "keyRaw": "manufacturers",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "inventoryTypeId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=3c65fe4fdc3911c6ab1cebe04f62900516f85381e96d3d59ce06a117e8684773";